"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { Patch, Post } from "@/shared/libs/axios/request";
import { orderKeys } from "@/entities/order";
import type {
  ProductOptionInput,
  ProductOptionResponse,
  UpdateProductOptionRequest,
} from "@stocks/shared";

export const useCreateProductOption = (productId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (values: ProductOptionInput) =>
      Post<ProductOptionResponse, ProductOptionInput>(
        `/v1/products/${productId}/options`,
        values,
      ),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: orderKeys.product(productId) });
      toast.success(res.data.message);
    },
    onError: (error) =>
      toast.error(error.response?.data.message ?? "옵션 등록에 실패했습니다."),
  });
};

export const useUpdateProductOption = (productId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      optionId,
      values,
    }: {
      optionId: string;
      values: UpdateProductOptionRequest;
    }) =>
      Patch<ProductOptionResponse, UpdateProductOptionRequest>(
        `/v1/products/${productId}/options/${optionId}`,
        values,
      ),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: orderKeys.product(productId) });
      toast.success(res.data.message);
    },
    onError: (error) =>
      toast.error(error.response?.data.message ?? "옵션 수정에 실패했습니다."),
  });
};
